export interface RankingEntry {
  rank: number;
  name: string;
  region: string;
  score: number;
  winRate: string;
  matches: number;
  change: 'up' | 'down' | 'same';
  changeValue: number;
}

export const rankings: RankingEntry[] = [
  { rank: 1, name: '王浩然', region: '北京', score: 9842, winRate: '87.5%', matches: 128, change: 'same', changeValue: 0 },
  { rank: 2, name: '陈晓峰', region: '广州', score: 9798, winRate: '85.2%', matches: 115, change: 'up', changeValue: 3 },
  { rank: 3, name: '张磊', region: '上海', score: 9650, winRate: '83.1%', matches: 132, change: 'down', changeValue: 1 },
  { rank: 4, name: '赵雪', region: '深圳', score: 9520, winRate: '81.8%', matches: 108, change: 'same', changeValue: 0 },
  { rank: 5, name: '刘思雨', region: '成都', score: 9410, winRate: '80.5%', matches: 98, change: 'up', changeValue: 5 },
  { rank: 6, name: '周强', region: '杭州', score: 9350, winRate: '79.3%', matches: 120, change: 'down', changeValue: 2 },
  { rank: 7, name: '林美琪', region: '南京', score: 9210, winRate: '78.6%', matches: 95, change: 'up', changeValue: 1 },
  { rank: 8, name: '黄建平', region: '武汉', score: 9080, winRate: '77.2%', matches: 110, change: 'down', changeValue: 3 },
  { rank: 9, name: '孙悦', region: '重庆', score: 8950, winRate: '76.0%', matches: 88, change: 'up', changeValue: 2 },
  { rank: 10, name: '吴天宇', region: '天津', score: 8820, winRate: '74.8%', matches: 102, change: 'same', changeValue: 0 },
];